import {
	Select,
	Text,
	Textarea,
	Upload,
	TimeDuration,
	Number,
	FormGroupInterface,
	FORM_TYPE,
	VALIDATION_TYPE,
	DFORM_BUTTON_DIRECTION,
	Aadhar,
	InputGroup,
	DDate,
	STRING
} from 'projects/common/src/app/types';
export function getTcDetailForm(data: any = {}, on: any = {}, disable: any= {}) {
	const tcDetailsForm: FormGroupInterface = {
		label: data.label || '',
		type: FORM_TYPE.WITHOUT_STYLE,
		labelDiv: 3,
		inputDiv: 8,
		forms: [
			{
				label: '',
				disabled: true,
				formElements: [
					new Text('Name', {
						name: 'tcName',
						align: 6,
					}),
					new Text('TC ID', {
						name: 'tcUserName',
						align: 6,
					}),
					new Text('Training Partner Name', {
						name: 'tpName',
						align: 6,
					}),
					new Text('TP ID', {
						name: 'tpUserName',
						align: 6,
					}),
				]
			},
			{
				label: 'Address Details',
				disabled: true,
				formElements: [
					new Textarea('Address:', {
						name: 'address',
					}),
					new Text('Near Landmark', {
						name: 'landmark',
					}),
					new Text('Pincode', {
						name: 'pincode',
					}),
					new Text('State / Union Teritory', {
						name: 'state',
					}),
					new Text('District', {
						name: 'district',
					}),
					new Text('Tehsil / Mandal / Block', {
						name: 'tehsil',
					}),
					new Text('City / Village / Town', {
						name: 'village',
					}),
					new Text('Parliamentary Constituency', {
						name: 'parliamentaryConstituency',
					}),
				]
			}, {
				label: 'Single Point of Contact Info:',
				disabled: true,
				formElements: [
					new Text('Name of the SPOC:', {
						name: 'spocName',
						align: 6
					}),
					new Text('Email Address:', {
						name: 'email',
						align: 6
					}),
					new Text('Phone Number:', {
						name: 'mobileNumber',
						align: 6
					})
				]
			}
		]
	};
	return tcDetailsForm;
}
